import { c as _c } from "react/compiler-runtime";
import { useFeatureFlagVariantKey } from 'posthog-js/react';

/**
 * EXPERIMENT: This hook is part of the application essay minimum character count experiment.
 * Code will be reverted after the experiment concludes.
 * See: application-essay-minimum-character-count feature flag
 *
 * Hook to get the minimum character count for the application essay based on PostHog feature flag variant.
 * Returns the appropriate minimum character count based on the user's assigned variant for the
 * 'application-essay-minimum-character-count' feature flag.
 *
 * @returns The minimum character count (default: 200)
 */
export function useApplicationEssayMinChars() {
  const $ = _c(1);
  const variantKey = useFeatureFlagVariantKey("application-essay-minimum-character-count");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      control: 200,
      "100-characters": 100,
      "150-characters": 150,
      "300-characters": 300,
      "400-characters": 400
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const variantCharMap = t0;
  if (typeof variantKey === "string" && variantKey in variantCharMap) {
    return variantCharMap[variantKey];
  }
  return 200;
}